// 納入事例カルーセル（スクラッチ / ネイティブ scroll-snap + prev/next 矢印）。
// マークアップ: [data-case] > [data-case-track] (カード群) + [data-case-prev]/[data-case-next]
// スワイプ/スクロールはネイティブ（慣性）に任せ、PC の矢印で1カード分スクロール。端で disabled。

function initCaseCarousel(root: HTMLElement): void {
  const track = root.querySelector<HTMLElement>("[data-case-track]");
  const prev = root.querySelector<HTMLButtonElement>("[data-case-prev]");
  const next = root.querySelector<HTMLButtonElement>("[data-case-next]");
  if (!track) return;

  // カード1枚分 + gap の移動量
  const step = (): number => {
    const card = track.querySelector<HTMLElement>(":scope > *");
    if (!card) return track.clientWidth;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  };

  const update = (): void => {
    const max = track.scrollWidth - track.clientWidth;
    const x = track.scrollLeft;
    if (prev) prev.disabled = x <= 1;
    if (next) next.disabled = x >= max - 1;
  };

  prev?.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
  next?.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
  track.addEventListener("scroll", () => window.requestAnimationFrame(update), { passive: true });
  window.addEventListener("resize", update, { passive: true });
  update();
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll<HTMLElement>("[data-case]").forEach((el) => initCaseCarousel(el));
});

export {};
